<template>
    <div class="ExamineResult_container">
        <div class="column_list" v-if="channelList.length">
            <ul>
                <li v-for="(item,index) in channelList" :key="index"
                    @click="item.url ? goDetail(item.url) : 'javascript:;'"
                >
                    <div class="release_info">
                        <div>
                            <YD-image src="icon/新闻公告"></YD-image>
                            <span>培训</span>
                        </div>
                        <div class="release_time">{{item.addDate | dateFormat('yyyy年M月d日发布')}}</div>
                    </div>
                    <div class="communique_content">
                        <div class="communique_title">{{item.title}}</div>
                        <YD-image src="match_detail/icon赛程赛果"></YD-image>
                    </div>
                </li>
            </ul>
        </div>
        <template v-if="!trainEnd">
            <Text-prompt :text="loadMore" noDataImg="no_data/暂无内容@2x.png" v-if="loadMore"></Text-prompt>
        </template>
        <template v-else>
            <div class="ranking_title" v-show="classList.length">
                <ul>
                    <li>序号/姓名</li>
                    <li v-if="isUserInfo">证件号码</li>
                </ul>
                <div class="select_class" :class="{'show': showSelectClass}" @click.stop="showSelectClass = !showSelectClass">
                    <span>{{className}}</span>
                    <YD-image :src="showSelectClass ? 'icon/icon_下拉箭头_绿色_向上':'icon/icon_下拉箭头_绿色_向下'"></YD-image>
                    <div class="class_list" v-show="showSelectClass">
                        <ul>
                            <li 
                                v-for="(item,index) in classList" :key="index" 
                                :class="{'active':classId == item.ClassId}"
                                @click.stop="selectClass(item)"
                            >{{item.ClassName}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="ranking_content">
                <ul>
                    <li v-for="(item,index) in list" :key="index">
                        <div class="info">
                            <i>{{index + 1}}</i>
                            <span>{{item.Name || ""}}</span>
                        </div>
						<div class="result" v-if="isUserInfo">{{item.IdentityNo || ""}}</div>
						<div class="class">{{item.CertNo || ""}}</div>
                    </li>
                </ul>
            </div>
            <template v-if="listLoadMore">
                <Text-prompt :text="listLoadMore" noDataImg="no_data/暂无内容@2x.png"></Text-prompt>
            </template>
        </template>
    </div>
</template>
<script>
import appInteraction from "@/common/appInteraction";
export default {
    props:{
        trainId:{
            type: Number,
            default: 0
        },
        channelUrl:{
            type: String,
            default: ''
        },
        trainEnd:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            channelList: [],
            classId: 0,
            className: '',
            showSelectClass: false,
            classList: [],
			isUserInfo: true,
            list: [],
            loadMore:'加载中...',
            listLoadMore: '加载中...'
        }
    },
    created(){
        this.getNewsList();
        if (this.trainEnd) {
            this.getDataList();
        }
    },
    mounted() {
        var _this = this;
        window.onclick = function(){
            if(_this.showSelectClass){
                _this.showSelectClass = false;
            }
        }
    },
    destroyed(){
        window.onclick = null;
    },
    methods:{
        getNewsList(){
            if (this.channelUrl) {
                this.$api.json(this.channelUrl).then(data=>{
                    this.channelList = data.contents || [];
                    this.loadMore = this.channelList.length > 0 ? "" : "无数据";
                }).catch(()=>{
                    this.loadMore = "数据加载失败";
                })
            } else {
                this.loadMore = "无数据";
            }
        },
        goDetail(url){
            appInteraction.webviewOpenUrl(this.cmsIsDomain(url));
        },
        cmsIsDomain(url){
            if(!(/^http|https/.test(url))){
                url = process.env.VUE_APP_CMS_URL + url;
            }
            return url;
        },
        selectClass(item) {
            this.showSelectClass = false;
            if (this.classId != item.ClassId) {
                this.classId = item.ClassId;
                this.className = item.ClassName;
                this.getDataList();
            }
        },
        getDataList() {
            this.listLoadMore = '加载中...';
            this.$api.GetTrainClassScoreList({
                "TrainId": this.trainId,
                "ClassId": this.classId
            }).then(data => {
                this.listLoadMore = '';
                if (data.Code === 0) {
                    if (this.classList.length == 0 && data.TrainClasses && data.TrainClasses.length >
                        0) {
                            this.classList = data.TrainClasses;
                    }
                    this.isUserInfo = true;
                    if(data.CurrentClass){
                        let info = data.CurrentClass;
                        this.classId = info.ClassId;
                        this.className = info.ClassName;
                        if(info.ClassConfig){
                            this.isUserInfo = !info.ClassConfig.NoUserInfo;
                        }
                    }
                    if(data.ScoreList && data.ScoreList.length){
                        this.list = data.ScoreList;
                    }else{
                        this.list = [];
                        this.listLoadMore = "无数据";
                    }
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.ExamineResult_container{
    .column_list{
        width: 100%;
        height: auto;
        padding: 40px 0 56px 40px;
        box-sizing: border-box;
        ul li{
            width: 100%;
            height: auto;
            padding-right: 40px;
            box-sizing: border-box;
            border-bottom: 1px #F0F0F0 solid;
            margin-bottom: 33px;
            &:last-of-type{
                border-bottom: none;
                margin-bottom: 0;
            }
            .release_info{
                display: flex;
                align-items: center;
                justify-content: space-between;
                img{
                    width: 32px;
                    height: 32px;
                    margin-right: 14px;
                }
                div{
                    font-size: 24px;
                    color: #41454D;
                    font-weight: 400;
                    &.release_time{
                        color: #999999;
                    }
                }
            }
            .communique_content{
                padding: 32px 0 34px;
                display: flex;
                justify-content: space-between;
                .communique_title{
                    width: 420px;
                    font-size: 32px;
                    color: #1B1C1E;
                    font-weight: 500;
                    line-height: 44px;
                }
                img{
                    width: 128px;
                    height: 128px;
                }
            }
        }
    }
    .ranking_title{
        width: 100%;
        height: 80px;
        background: #FFFFFF;
        position: sticky;
        z-index: 1;
        left: 0;
        display: flex;
        align-items: center;
        >ul{
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            >li{
                font-size: 28px;
                color: #B9B9B9;
                font-weight: 500;
                &:nth-of-type(1){
					flex: 1;
                    padding-left: 40px;
                    box-sizing: border-box;
                }
                &:nth-of-type(2){
                    flex: none;
                    width: 162px;
                    text-align: center;
                    white-space: nowrap;
                }
            }
        }
        .select_class{
            flex: none;
            width: 298px;
            height: 100%;
            border-left: 2px #F2F2F2 solid;
            padding-left: 10px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            
            font-size: 26px;
            color: #7AD21A;
            line-height: 40px;
            font-weight: 500;
            &.show{
                background: #F2F2F2;
            }
            span{
                max-width: 180px;
                white-space: nowrap;
                @include ellipsis;
            }
            img{
                width: 32px;
                height: 32px;
            }
            .class_list{
                width: auto;
                height: auto;
                background: #FFFFFF;
                border: 2px solid rgba(151,151,151,0.16);
                box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.4);
                border-radius: 0px 0px 10px 10px;
                padding: 24px 0;
                box-sizing: border-box;
                position: absolute;
                top: 100%;
                right: 0;
                z-index: 1;
                ul{
                    width: auto;
                    height: auto;
                    max-height: 564px;
                    overflow-y: auto;
                    li{
                        min-width: 298px;
                        max-width: 450px;
                        height: 76px;
                        font-size: 32px;
                        font-weight: 500;
                        text-align: center;
                        line-height: 76px;
                        color: #8B8C8D;
                        white-space: nowrap;
                        padding: 0 24px;
                        box-sizing: border-box;
                        @include ellipsis;
                        &.active{
                            color: #7AD21A;
                            background: #F3F3F3;
                        }
                    }
                } 
            }
        }
    }
    .ranking_content{
        width: 100%;
        height: auto;
        ul{
            width: 100%;
            height: auto;
            li{
                width: 100%;
                padding: 20px 0;
                background: #FAFBFA;
                font-size: 28px;
                font-weight: 400;
                line-height: 40px;
                display: flex;
                &:nth-of-type(2n){
                    background: #FFFFFF;
                }
                .info{
                    flex: 1;
                    color: #1B1C1E;
                    padding-left: 40px;
                    box-sizing: border-box;
                    i{
                        width: 52px;
                        height: 100%;
                        display: inline-block;
                        color: #F79611;
                        font-weight: 600;
                        vertical-align: top;
                    }
                    span{
                        width: calc(100% - 52px - 40px);
                        display: inline-block;
                    }
                }
                .result {
                    flex: none;
                    width: 162px;
                    color: #666666;
                }
                .class{
                    flex: none;
                    width: 298px;
                    box-sizing: border-box;
                    text-align: center;
                    color: #666666;
                }
            }
        }
    }
}
</style>